import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getModelType = (modelTypeId: number | undefined): Promise<IGetModelType> => {
  return axiosDefaultApi.get(`/api/ModelTypes/GetModelTypeViaID/${modelTypeId}`);
};

type QueryFnType = typeof getModelType;

type UseGetModelTypeOptions = {
  modelTypeId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetModelType = ({ modelTypeId , config }: UseGetModelTypeOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getModelType_${modelTypeId}`],
    queryFn: () => getModelType(modelTypeId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους Συσκευής`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};